import { defineComponent } from 'navigation-components/platform/models';
import { capabilities } from '../../capabilities';
import { getPortalId } from '../../common/utils';
import { MARKETPLACE_NAV_MENU_COMPONENT } from '../constants';
import { getQueryParams } from './internal/getQueryParams';
export const marketplaceNavMenuComponentDef = defineComponent(MARKETPLACE_NAV_MENU_COMPONENT, {
  path: `/marketplace-embed/${getPortalId()}/navigation-menu`,
  queryParams: getQueryParams(),
  name: MARKETPLACE_NAV_MENU_COMPONENT,
  capabilities: [capabilities.NAVIGATE_TO_CAP.getName(), capabilities.RESTYLE_CAP.getName()],
  deferLoading: true,
  initiallyOpen: false,
  iframeProps: {
    style: {
      position: 'absolute',
      height: '0'
    }
  },
  renderTo: () => document.querySelector('#marketplace-nav-menu')
});